import { useUserSelector } from '~/hooks/useUserSelector';

/**
 * The office the app is scoped to: the selected child office, else the signed-in
 * one (`selectedChildOffice ?? user`), the same rule as mobile and as
 * `useUpdateLocationCredentials`. Under the DSO structure with no office selected
 * (oversight) that is the parent, so its page treats it as the selected office.
 */
export const useScopedOfficeId = (): string | undefined => useUserSelector()?.id;
